import PageStyle from "@/styles/pages/errors/_index.module.scss";
import Image from "next/image";
import { useTranslation } from "react-i18next";

export default function Error403() {
  const { t } = useTranslation();
  return (
    <div className={`${PageStyle.NewJob}`}>
      <div className={PageStyle.NewJob__Container}>
        <div className={`${PageStyle.Error} ${PageStyle.ErrorAlign}`}>
          <Image
            src="/images/errors/403.png"
            height={217}
            width={291}
            alt=""
          ></Image>
          <h1>{t('errors:authentication')}</h1>
          <h4 className={`mb0 mt0 ${PageStyle.mw95}`}>
            {t('errors:no_permission')} <br />
            {t('errors:login_with_other')}
          </h4>
        </div>
      </div>
    </div>
  );
}
